export const S_ENVIRONMENT: string = process?.env?.SECURE_ENVIRONMENT
  ? process?.env?.SECURE_ENVIRONMENT?.toString().trim()
  : 'dev'
export const IS_PRODUCTION: boolean = S_ENVIRONMENT == 'prod' ? true : false
export const IS_QA: boolean = S_ENVIRONMENT == 'dev' ? true : false
export const IS_LOCAL: boolean = S_ENVIRONMENT == 'local' ? true : false
export const AI_PROMPT_ENABLED: boolean = true
export const TEST_EMBEDDED: boolean = false
export const S_HOST: string = process?.env?.SECURE_HOST
  ? process?.env?.SECURE_HOST.toString().trim()
  : ''
export const P3_API_DOMAIN: string = process?.env?.SECURE_P3_API_DOMAIN
  ? process?.env?.SECURE_P3_API_DOMAIN?.toString().trim()
  : ''
export const P3_API_ACTION_SECRET: string = process?.env
  ?.SECURE_P3_API_ACTION_SECRET
  ? process?.env?.SECURE_P3_API_ACTION_SECRET?.toString().trim()
  : ''
export const ENV_PASSCODE: string = process?.env?.SECURE_ENV_PASSCODE
  ? process?.env?.SECURE_ENV_PASSCODE?.toString().trim()
  : ''
export const GOOGLE_ANALYTICS_MEASUREMENT_PROTOCOL_API_SECRET: string = process
  ?.env?.SECURE_GOOGLE_ANALYTICS_MEASUREMENT_PROTOCOL_API_SECRET
  ? process?.env?.SECURE_GOOGLE_ANALYTICS_MEASUREMENT_PROTOCOL_API_SECRET?.toString().trim()
  : ''
export const GOOGLE_SERVICE_ACCOUNT_PROJECT_ID: string = process?.env
  ?.SECURE_GOOGLE_SERVICE_ACCOUNT_PROJECT_ID
  ? process?.env?.SECURE_GOOGLE_SERVICE_ACCOUNT_PROJECT_ID?.toString().trim()
  : ''
export const GOOGLE_SERVICE_ACCOUNT_CLIENT_EMAIL: string = process?.env
  ?.SECURE_GOOGLE_SERVICE_ACCOUNT_CLIENT_EMAIL
  ? process?.env?.SECURE_GOOGLE_SERVICE_ACCOUNT_CLIENT_EMAIL?.toString().trim()
  : ''
export const FIREBASE_DATABASE_URL: string = process?.env
  ?.SECURE_FIREBASE_DATABASE_URL
  ? process?.env?.SECURE_FIREBASE_DATABASE_URL?.toString().trim()
  : ''
export const MAGIC_LINK_SECRET = process?.env?.SECURE_MAGIC_LINK_SECRET
  ? process.env.SECURE_MAGIC_LINK_SECRET.toString().trim()
  : ''
export const NEXTAUTH_URL: string = process?.env?.NEXTAUTH_URL
  ? process?.env?.NEXTAUTH_URL?.toString().trim()
  : ''
export const S_APP_DOMAIN: string = process?.env?.SECURE_APP_DOMAIN
  ? process?.env?.SECURE_APP_DOMAIN?.toString().trim()
  : ''
export const S_DEBUG_MODE: boolean = process?.env?.SECURE_APP_WIDE_DEBUG_MODE
  ? process?.env?.SECURE_APP_WIDE_DEBUG_MODE?.toString().trim() == 'true'
    ? true
    : false
  : false
export const S_ACCOUNT_SETTINGS_REDIRECT_UUID: string = process?.env
  ?.SECURE_ACCOUNT_SETTINGS_REDIRECT_UUID
  ? process?.env?.SECURE_ACCOUNT_SETTINGS_REDIRECT_UUID?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_LOCATION_SCHEDULE: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_LOCATION_SCHEDULE
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_LOCATION_SCHEDULE?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_LOCATION_SCHEDULE_TEMPLATES: string = process
  ?.env?.SECURE_P3_API_ENDPOINT_GET_LOCATION_SCHEDULE_TEMPLATES
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_LOCATION_SCHEDULE_TEMPLATES?.toString().trim()
  : ''
export const P3_API_ENDPOINT_POST_LOCATION_SCHEDULE: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_POST_LOCATION_SCHEDULE
  ? process?.env?.SECURE_P3_API_ENDPOINT_POST_LOCATION_SCHEDULE?.toString().trim()
  : ''
export const P3_API_ENDPOINT_POST_LOCATION_SCHEDULE_TEMPLATE: string = process
  ?.env?.SECURE_P3_API_ENDPOINT_POST_LOCATION_SCHEDULE_TEMPLATE
  ? process?.env?.SECURE_P3_API_ENDPOINT_POST_LOCATION_SCHEDULE_TEMPLATE?.toString().trim()
  : ''
export const P3_API_ENDPOINT_POST_LOCATION_SCHEDULE_EXCEPTION_DATE: string =
  process?.env?.SECURE_P3_API_ENDPOINT_POST_LOCATION_SCHEDULE_EXCEPTION_DATE
    ? process?.env?.SECURE_P3_API_ENDPOINT_POST_LOCATION_SCHEDULE_EXCEPTION_DATE?.toString().trim()
    : ''
export const P3_API_ENDPOINT_POST_LOCATION_SCHEDULE_EXCEPTION_DATES: string =
  process?.env?.SECURE_P3_API_ENDPOINT_POST_LOCATION_SCHEDULE_EXCEPTION_DATES
    ? process?.env?.SECURE_P3_API_ENDPOINT_POST_LOCATION_SCHEDULE_EXCEPTION_DATES?.toString().trim()
    : ''
export const P3_API_ENDPOINT_GET_LICENSED_USER_CONTRACTS: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_LICENSED_USER_CONTRACTS
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_LICENSED_USER_CONTRACTS.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_ENTRY_ALL_BULK_LICENSED_URL: string = process
  ?.env?.SECURE_P3_API_ENDPOINT_GET_ENTRY_ALL_BULK_LICENSED_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_ENTRY_ALL_BULK_LICENSED_URL?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_SOME_ENTRY_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_SOME_ENTRY_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_SOME_ENTRY_URL.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_FAVORITES_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_FAVORITES_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_FAVORITES_URL.toString().trim()
  : ''
export const P3_API_ENDPOINT_POST_FAVORITE_WEB2_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_POST_FAVORITE_WEB2_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_POST_FAVORITE_WEB2_URL.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_CONTRACT_GENRE: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_CONTRACT_GENRE
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_CONTRACT_GENRE.toString().trim()
  : ''
export const P3_API_ENDPOINT_POST_PLAYLIST_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_POST_PLAYLIST_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_POST_PLAYLIST_URL?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_BUSINESS_ARTISTS: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_BUSINESS_ARTISTS
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_BUSINESS_ARTISTS?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_GENRE_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_GENRE_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_GENRE_URL.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_MINT_BULK_LICENSED: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_MINT_BULK_LICENSED
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_MINT_BULK_LICENSED?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_PLAYLIST_WEB2_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_PLAYLIST_WEB2_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_PLAYLIST_WEB2_URL?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_PLAYLIST_ALL_WEB2_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_PLAYLIST_ALL_WEB2_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_PLAYLIST_ALL_WEB2_URL.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_PRESET_SAMPLES: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_PRESET_SAMPLES
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_PRESET_SAMPLES?.toString().trim()
  : ''
export const P3_API_ENDPOINT_POST_PLAYLIST_ENTRIES_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_POST_PLAYLIST_ENTRIES_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_POST_PLAYLIST_ENTRIES_URL.toString().trim()
  : ''
export const P3_API_ENDPOINT_POST_PLAYLIST_ENTRY_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_POST_PLAYLIST_ENTRY_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_POST_PLAYLIST_ENTRY_URL.toString().trim()
  : ''
export const P3_API_ENDPOINT_DELETE_PLAYLIST_ENTRY_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_DELETE_PLAYLIST_ENTRY_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_DELETE_PLAYLIST_ENTRY_URL.toString().trim()
  : ''
export const P3_API_ENDPOINT_INSERT_STREAM: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_INSERT_STREAM
  ? process?.env?.SECURE_P3_API_ENDPOINT_INSERT_STREAM.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_USER_WEB2_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_USER_WEB2_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_USER_WEB2_URL.toString().trim()
  : ''
export const P3_API_ENDPOINT_POST_USER_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_POST_USER_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_POST_USER_URL.toString().trim()
  : ''
export const P3_API_ENDPOINT_SIGN_OUT_OF_MULTIPLE_LOCATIONS: string = process
  ?.env?.SECURE_P3_API_ENDPOINT_SIGN_OUT_OF_MULTIPLE_LOCATIONS
  ? process?.env?.SECURE_P3_API_ENDPOINT_SIGN_OUT_OF_MULTIPLE_LOCATIONS?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_LAST_MULTIPLE_LOCATIONS_SIGN_OUT: string =
  process?.env?.SECURE_P3_API_ENDPOINT_GET_LAST_MULTIPLE_LOCATIONS_SIGN_OUT
    ? process?.env?.SECURE_P3_API_ENDPOINT_GET_LAST_MULTIPLE_LOCATIONS_SIGN_OUT.toString().trim()
    : ''
export const P3_API_ENDPOINT_GET_UNSUBSCRIBE_BUSINESS_USER = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_UNSUBSCRIBE_BUSINESS_USER
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_UNSUBSCRIBE_BUSINESS_USER.toString().trim()
  : ''
export const P3_API_ENDPOINT_NOTIFY_USER_UNSUBSCRIBED = process?.env
  ?.SECURE_P3_API_ENDPOINT_NOTIFY_USER_UNSUBSCRIBED
  ? process?.env?.SECURE_P3_API_ENDPOINT_NOTIFY_USER_UNSUBSCRIBED.toString().trim()
  : ''
export const P3_API_ENDPOINT_POST_ADMIN_REPORT_ENABLED = process?.env
  ?.SECURE_P3_API_ENDPOINT_POST_ADMIN_REPORT_ENABLED
  ? process?.env?.SECURE_P3_API_ENDPOINT_POST_ADMIN_REPORT_ENABLED?.toString().trim()
  : ''
export const P3_API_ENDPOINT_UNSUBSCRIBE_FROM_EMAILS: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_UNSUBSCRIBE_FROM_EMAILS
  ? process?.env?.SECURE_P3_API_ENDPOINT_UNSUBSCRIBE_FROM_EMAILS?.toString().trim()
  : ''
export const P3_API_ENDPOINT_POST_NOTIFICATION_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_POST_NOTIFICATION_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_POST_NOTIFICATION_URL?.toString().trim()
  : ''
export const P3_API_ENDPOINT_DECLINE_INVITATION_NOTIFICATION_URL: string =
  process?.env?.SECURE_P3_API_ENDPOINT_DECLINE_INVITATION_NOTIFICATION_URL
    ? process?.env?.SECURE_P3_API_ENDPOINT_DECLINE_INVITATION_NOTIFICATION_URL?.toString().trim()
    : ''
export const P3_API_ENDPOINT_GET_ALL_NOTIFICATION_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_ALL_NOTIFICATION_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_ALL_NOTIFICATION_URL?.toString().trim()
  : ''
export const P3_API_ENDPOINT_PERSIST_CHECKOUT_DATA: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_PERSIST_CHECKOUT_DATA
  ? process?.env?.SECURE_P3_API_ENDPOINT_PERSIST_CHECKOUT_DATA?.toString().trim()
  : ''
export const P3_API_ENDPOINT_SEND_CONTACT_FORM_SUBMISSION: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_SEND_CONTACT_FORM_SUBMISSION
  ? process?.env?.SECURE_P3_API_ENDPOINT_SEND_CONTACT_FORM_SUBMISSION?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_SUBSCRIPTION_USERS: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_SUBSCRIPTION_USERS
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_SUBSCRIPTION_USERS?.toString().trim()
  : ''
export const P3_API_ENDPOINT_SYNC_MEMBERS: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_SYNC_MEMBERS
  ? process?.env?.SECURE_P3_API_ENDPOINT_SYNC_MEMBERS?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_USER_GROUPS: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_USER_GROUPS
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_USER_GROUPS?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_POST_USER_GROUP: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_POST_USER_GROUP
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_POST_USER_GROUP?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_ADD_USER_TO_GROUP: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_ADD_USER_TO_GROUP
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_ADD_USER_TO_GROUP?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_REMOVE_USER_FROM_GROUP: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_REMOVE_USER_FROM_GROUP
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_REMOVE_USER_FROM_GROUP?.toString().trim()
  : ''
export const P3_API_ENDPOINT_NOTIFY_HARDWARE_USER_DELETED: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_NOTIFY_HARDWARE_USER_DELETED
  ? process?.env?.SECURE_P3_API_ENDPOINT_NOTIFY_HARDWARE_USER_DELETED?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_INVITATIONS: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_INVITATIONS
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_INVITATIONS?.toString().trim()
  : ''
export const P3_API_ENDPOINT_RESEND_SINGLE_INVITATION: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_RESEND_SINGLE_INVITATION
  ? process?.env?.SECURE_P3_API_ENDPOINT_RESEND_SINGLE_INVITATION?.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_INVITATION: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_INVITATION
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_INVITATION?.toString().trim()
  : ''
export const P3_API_ENDPOINT_SEND_BULK_INVITATIONS: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_SEND_BULK_INVITATIONS
  ? process?.env?.SECURE_P3_API_ENDPOINT_SEND_BULK_INVITATIONS?.toString().trim()
  : ''
export const P3_API_ENDPOINT_CREATE_BULK_INVITATIONS = process?.env
  ?.SECURE_P3_API_ENDPOINT_CREATE_BULK_INVITATIONS
  ? process?.env?.SECURE_P3_API_ENDPOINT_CREATE_BULK_INVITATIONS?.toString().trim()
  : ''
export const P3_API_ENDPOINT_POST_INVITATION: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_POST_INVITATION
  ? process?.env?.SECURE_P3_API_ENDPOINT_POST_INVITATION?.toString().trim()
  : ''

export const P3_API_ENDPOINT_UNDECLINE_INVITATION: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_UNDECLINE_INVITATION
  ? process?.env?.SECURE_P3_API_ENDPOINT_UNDECLINE_INVITATION?.toString().trim()
  : ''
export const P3_API_ENDPOINT_POST_BUSINESS_CREDIT_USER_LEDGER_EVENT: string =
  process?.env?.SECURE_P3_API_ENDPOINT_POST_BUSINESS_CREDIT_USER_LEDGER_EVENT
    ? process?.env?.SECURE_P3_API_ENDPOINT_POST_BUSINESS_CREDIT_USER_LEDGER_EVENT?.toString().trim()
    : ''
export const STRIPE_BILLING_PORTAL_DEFAULT_PAYMENT_METHODS_ONLY_VIEW_CONFIGURATION_ID: string =
  process?.env
    ?.SECURE_STRIPE_BILLING_PORTAL_DEFAULT_PAYMENT_METHODS_ONLY_VIEW_CONFIGURATION_ID
    ? process?.env?.SECURE_STRIPE_BILLING_PORTAL_DEFAULT_PAYMENT_METHODS_ONLY_VIEW_CONFIGURATION_ID?.toString().trim()
    : ''
export const STRIPE_BILLING_PORTAL_TEMPORARY_LINK_CONFIGURATION_ID: string =
  process?.env?.SECURE_STRIPE_BILLING_PORTAL_TEMPORARY_LINK_CONFIGURATION_ID
    ? process?.env?.SECURE_STRIPE_BILLING_PORTAL_TEMPORARY_LINK_CONFIGURATION_ID?.toString().trim()
    : ''
export const P3_API_ENDPOINT_GET_BUSINESS_CREDIT_USER: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_BUSINESS_CREDIT_USER
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_BUSINESS_CREDIT_USER?.toString().trim()
  : ''
export const P3_API_ENDPOINT_PERSIST_USER_CREDITS_CHECKOUT_DATA: string =
  process?.env?.SECURE_P3_API_ENDPOINT_PERSIST_USER_CREDITS_CHECKOUT_DATA
    ? process?.env?.SECURE_P3_API_ENDPOINT_PERSIST_USER_CREDITS_CHECKOUT_DATA?.toString().trim()
    : ''
export const P3_API_ENDPOINT_SUBSCRIPTION_AI_AGENT_CHECKOUT: string = process
  ?.env?.SECURE_P3_API_ENDPOINT_SUBSCRIPTION_AI_AGENT_CHECKOUT
  ? process?.env?.SECURE_P3_API_ENDPOINT_SUBSCRIPTION_AI_AGENT_CHECKOUT?.toString().trim()
  : ''
export const UPSTASH_API_KEY: string = process?.env?.SECURE_UPSTASH_API_KEY
  ? process?.env?.SECURE_UPSTASH_API_KEY
  : ''
export const UPSTASH_ENDPOINT: string = process?.env?.SECURE_UPSTASH_ENDPOINT
  ? process?.env?.SECURE_UPSTASH_ENDPOINT
  : ''
export const P3_API_ENDPOINT_POST_CUSTOMER_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_POST_CUSTOMER_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_POST_CUSTOMER_URL.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_CUSTOMER_URL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_CUSTOMER_URL
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_CUSTOMER_URL.toString().trim()
  : ''
export const P3_API_ENDPOINT_GET_UNSUBSCRIBED_EMAIL: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_GET_UNSUBSCRIBED_EMAIL
  ? process?.env?.SECURE_P3_API_ENDPOINT_GET_UNSUBSCRIBED_EMAIL?.toString().trim()
  : ''
export const P3_API_ENDPOINT_PROMPT_AI: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_PROMPT_AI
  ? process?.env?.SECURE_P3_API_ENDPOINT_PROMPT_AI?.toString().trim()
  : ''
export const P3_API_ENDPOINT_PERSIST_NEW_APP_VERSION: string = process?.env
  ?.SECURE_P3_API_ENDPOINT_PERSIST_NEW_APP_VERSION
  ? process?.env?.SECURE_P3_API_ENDPOINT_PERSIST_NEW_APP_VERSION?.toString().trim()
  : ''
export const DECRYPT_URL_PASSPHRASE: string = process?.env
  ?.SECURE_DECRYPT_URL_PASSPHRASE
  ? process?.env?.SECURE_DECRYPT_URL_PASSPHRASE?.toString().trim()
  : ''
export const STRIPE_SECRET_KEY: string = process?.env
  ?.SECURE_STRIPE_API_SECRET_KEY
  ? process?.env?.SECURE_STRIPE_API_SECRET_KEY?.toString().trim()
  : ''
export const STRIPE_SUBSCRIPTION_PRICE_ID: string = process?.env
  ?.SECURE_STRIPE_SUBSCRIPTION_PRICE_ID
  ? process?.env?.SECURE_STRIPE_SUBSCRIPTION_PRICE_ID?.toString().trim()
  : ''
export const STRIPE_SUBSCRIPTION_PRICE_ID_HARDWARE: string = process?.env
  ?.SECURE_STRIPE_SUBSCRIPTION_PRICE_ID_HARDWARE
  ? process?.env?.SECURE_STRIPE_SUBSCRIPTION_PRICE_ID_HARDWARE?.toString().trim()
  : ''
export const STRIPE_BRAND_STUDIO_TOKEN_100_BUNDLE_PRICE_ID: string = process
  ?.env?.SECURE_STRIPE_BRAND_STUDIO_TOKEN_100_BUNDLE_PRICE_ID
  ? process?.env?.SECURE_STRIPE_BRAND_STUDIO_TOKEN_100_BUNDLE_PRICE_ID?.toString().trim()
  : ''
export const GEOLOCATION_DB_API_KEY: string = process?.env
  ?.SECURE_GEOLOCATION_DB_API_KEY
  ? process?.env?.SECURE_GEOLOCATION_DB_API_KEY?.toString().trim()
  : ''
export const REDIS_HOST: string = process?.env?.SECURE_REDIS_HOST
  ? process?.env?.SECURE_REDIS_HOST?.toString().trim()
  : ''
export const REDIS_PASSWORD: string = process?.env?.SECURE_REDIS_PASSWORD
  ? process?.env?.SECURE_REDIS_PASSWORD?.toString().trim()
  : ''
export const REDIS_USERNAME: string = process?.env?.SECURE_REDIS_USERNAME
  ? process?.env?.SECURE_REDIS_USERNAME?.toString().trim()
  : ''
export const REDIS_PORT: number = process?.env?.SECURE_REDIS_PORT
  ? parseInt(process?.env?.SECURE_REDIS_PORT?.toString().trim())
  : 11433
export const REDIS_REFRESH_TOKEN_INTERNAL_SECRET: string = process?.env
  ?.SECURE_REDIS_REFRESH_TOKEN_INTERNAL_SECRET
  ? process?.env?.SECURE_REDIS_REFRESH_TOKEN_INTERNAL_SECRET?.toString().trim()
  : ''
export const FIRECRAWL_API_KEY: string = process?.env?.SECURE_FIRECRAWL_API_KEY
  ? process?.env?.SECURE_FIRECRAWL_API_KEY?.toString().trim()
  : ''
export const RAW_ENTRIES_REDIS_LAST_CACHED: string = process?.env
  ?.SECURE_RAW_ENTRIES_REDIS_LAST_CACHED
  ? process?.env?.SECURE_RAW_ENTRIES_REDIS_LAST_CACHED?.toString().trim()
  : ''
export const RAW_ENTRIES_REDIS_CACHE_NAME_TEMP: string = process?.env
  ?.SECURE_RAW_ENTRIES_REDIS_CACHE_NAME_TEMP
  ? process?.env?.SECURE_RAW_ENTRIES_REDIS_CACHE_NAME_TEMP?.toString().trim()
  : ''
export const RAW_ENTRIES_REDIS_CACHE_NAME: string = process?.env
  ?.SECURE_RAW_ENTRIES_REDIS_CACHE_NAME
  ? process?.env?.SECURE_RAW_ENTRIES_REDIS_CACHE_NAME.toString().trim()
  : ''
export const MINIMUM_RAW_ENTRY_CREATED: string = IS_PRODUCTION
  ? '2024-06-14T10:09:25.554Z'
  : '2022-01-01T03:32:20.253Z'
export const GENRES_REDIS_LAST_CACHED: string = process?.env
  ?.SECURE_GENRES_REDIS_LAST_CACHED
  ? process?.env?.SECURE_GENRES_REDIS_LAST_CACHED?.toString().trim()
  : ''
export const ARTISTS_REDIS_CACHE_NAME: string = process?.env
  ?.SECURE_ARTISTS_REDIS_CACHE_NAME
  ? process?.env?.SECURE_ARTISTS_REDIS_CACHE_NAME?.toString().trim()
  : ''
export const ARTISTS_REDIS_LAST_CACHED: string = process?.env
  ?.SECURE_ARTISTS_REDIS_LAST_CACHED
  ? process?.env?.SECURE_ARTISTS_REDIS_LAST_CACHED?.toString().trim()
  : ''
export const GENRES_REDIS_CACHE_NAME: string = process?.env
  ?.SECURE_GENRES_REDIS_CACHE_NAME
  ? process?.env?.SECURE_GENRES_REDIS_CACHE_NAME?.toString().trim()
  : ''
export const ENTRIES_REDIS_LAST_CACHED: string = process?.env
  ?.SECURE_ENTRIES_REDIS_LAST_CACHED
  ? process?.env?.SECURE_ENTRIES_REDIS_LAST_CACHED?.toString().trim()
  : ''
export const ENTRIES_REDIS_CACHE_NAME: string = process?.env
  ?.SECURE_ENTRIES_REDIS_CACHE_NAME
  ? process?.env?.SECURE_ENTRIES_REDIS_CACHE_NAME?.toString().trim()
  : ''
export const GENRE_CONTRACTS_REDIS_LAST_CACHED: string = process?.env
  ?.SECURE_GENRE_CONTRACTS_REDIS_LAST_CACHED
  ? process?.env?.SECURE_GENRE_CONTRACTS_REDIS_LAST_CACHED?.toString().trim()
  : ''
export const GENRE_CONTRACTS_REDIS_CACHE_NAME: string = process?.env
  ?.SECURE_GENRE_CONTRACTS_REDIS_CACHE_NAME
  ? process?.env?.SECURE_GENRE_CONTRACTS_REDIS_CACHE_NAME?.toString().trim()
  : ''
export const LLMS_FULL_REDIS_LAST_CACHED: string = process?.env
  ?.SECURE_LLMS_FULL_REDIS_LAST_CACHED
  ? process?.env?.SECURE_LLMS_FULL_REDIS_LAST_CACHED?.toString().trim()
  : ''
export const LLMS_FULL_REDIS_CACHE_NAME: string = process?.env
  ?.SECURE_LLMS_FULL_REDIS_CACHE_NAME
  ? process?.env?.SECURE_LLMS_FULL_REDIS_CACHE_NAME.toString().trim()
  : ''
export const LLMS_REDIS_LAST_CACHED: string = process?.env
  ?.SECURE_LLMS_REDIS_LAST_CACHED
  ? process?.env?.SECURE_LLMS_REDIS_LAST_CACHED?.toString().trim()
  : ''
export const LLMS_REDIS_CACHE_NAME: string = process?.env
  ?.SECURE_LLMS_REDIS_CACHE_NAME
  ? process?.env?.SECURE_LLMS_REDIS_CACHE_NAME?.toString().trim()
  : ''
export const BLOG_HOST: string = process?.env?.NEXT_PUBLIC_BLOG_HOST
  ? process?.env?.NEXT_PUBLIC_BLOG_HOST?.toString().trim()
  : ''
export const GOOGLE_WEB_RISK_API_KEY: string = process?.env
  ?.SECURE_GOOGLE_WEB_RISK_API_KEY
  ? process?.env?.SECURE_GOOGLE_WEB_RISK_API_KEY?.toString().trim()
  : ''
export const UCP_SIGNING_KEY_PRIVATE: string = process?.env
  ?.SECURE_UCP_SIGNING_KEY_PRIVATE
  ? process?.env?.SECURE_UCP_SIGNING_KEY_PRIVATE.toString().trim()
  : ''
export const LLMS_RESPONSE_CACHE_REVALIDATE_MINUTES: number = 262080 // 26 weeks... 2 weeks = 20160
export const LLMS_FULL_RESPONSE_CACHE_REVALIDATE_MINUTES: number = 262080 // 26 weeks... 2 weeks = 20160
export const SERVER_TO_SERVER_USER_AGENT: string = 'ServerToServerBot'
export const SERVER_TO_SERVER_FETCH_SECRET: string =
  '277F5821-7F69-4B9D-B434-46FBF6AED06C'
export const ACCEPTABLE_SHIPPING_COUNTRIES_ISO3166: any = [
  'US',
  'CA',
  'AT',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GD',
  'GE',
  'GR',
  'GU',
  'HN',
  'HU',
  'ID',
  'IE',
  'IL',
  'IN',
  'IS',
  'IT',
  'JE',
  'JM',
  'JP',
  'KN',
  'KR',
  'KY',
  'LC',
  'LI',
  'LV',
  'LT',
  'LU',
  'LV',
  'MF',
  'ML',
  'MQ',
  'MT',
  'MV',
  'MY',
  'NL',
  'NO',
  'PG',
  'PL',
  'PT',
  'PY',
  'RO',
  'SB',
  'SG',
  'SK',
  'SI',
  'SE',
  'SV',
  'SX',
  'TC',
  'TH',
  'TK',
  'UY',
  'VA',
  'VC',
  'VE',
  'VG',
  'VU',
]
export const ACCEPTABLE_SHIPPING_COUNTRIES_ISO3166_FOR_JSON_LD_RAW: any = [
  '{ "@type": "Country", "name": "US" },',
  '{ "@type": "Country", "name": "CA" },',
  '{ "@type": "Country", "name": "AT" },',
  '{ "@type": "Country", "name": "BE" },',
  '{ "@type": "Country", "name": "BG" },',
  '{ "@type": "Country", "name": "CH" },',
  '{ "@type": "Country", "name": "CY" },',
  '{ "@type": "Country", "name": "CZ" },',
  '{ "@type": "Country", "name": "DE" },',
  '{ "@type": "Country", "name": "DK" },',
  '{ "@type": "Country", "name": "EE" },',
  '{ "@type": "Country", "name": "ES" },',
  '{ "@type": "Country", "name": "FI" },',
  '{ "@type": "Country", "name": "FR" },',
  '{ "@type": "Country", "name": "GB" },',
  '{ "@type": "Country", "name": "GD" },',
  '{ "@type": "Country", "name": "GE" },',
  '{ "@type": "Country", "name": "GR" },',
  '{ "@type": "Country", "name": "GU" },',
  '{ "@type": "Country", "name": "HN" },',
  '{ "@type": "Country", "name": "HU" },',
  '{ "@type": "Country", "name": "ID" },',
  '{ "@type": "Country", "name": "IE" },',
  '{ "@type": "Country", "name": "IL" },',
  '{ "@type": "Country", "name": "IN" },',
  '{ "@type": "Country", "name": "IS" },',
  '{ "@type": "Country", "name": "IT" },',
  '{ "@type": "Country", "name": "JE" },',
  '{ "@type": "Country", "name": "JM" },',
  '{ "@type": "Country", "name": "JP" },',
  '{ "@type": "Country", "name": "KN" },',
  '{ "@type": "Country", "name": "KR" },',
  '{ "@type": "Country", "name": "KY" },',
  '{ "@type": "Country", "name": "LC" },',
  '{ "@type": "Country", "name": "LI" },',
  '{ "@type": "Country", "name": "LV" },',
  '{ "@type": "Country", "name": "LT" },',
  '{ "@type": "Country", "name": "LU" },',
  '{ "@type": "Country", "name": "LV" },',
  '{ "@type": "Country", "name": "MF" },',
  '{ "@type": "Country", "name": "ML" },',
  '{ "@type": "Country", "name": "MQ" },',
  '{ "@type": "Country", "name": "MT" },',
  '{ "@type": "Country", "name": "MV" },',
  '{ "@type": "Country", "name": "MY" },',
  '{ "@type": "Country", "name": "NL" },',
  '{ "@type": "Country", "name": "NO" },',
  '{ "@type": "Country", "name": "PG" },',
  '{ "@type": "Country", "name": "PL" },',
  '{ "@type": "Country", "name": "PT" },',
  '{ "@type": "Country", "name": "PY" },',
  '{ "@type": "Country", "name": "RO" },',
  '{ "@type": "Country", "name": "SB" },',
  '{ "@type": "Country", "name": "SG" },',
  '{ "@type": "Country", "name": "SK" },',
  '{ "@type": "Country", "name": "SI" },',
  '{ "@type": "Country", "name": "SE" },',
  '{ "@type": "Country", "name": "SV" },',
  '{ "@type": "Country", "name": "SX" },',
  '{ "@type": "Country", "name": "TC" },',
  '{ "@type": "Country", "name": "TH" },',
  '{ "@type": "Country", "name": "TK" },',
  '{ "@type": "Country", "name": "UY" },',
  '{ "@type": "Country", "name": "VA" },',
  '{ "@type": "Country", "name": "VC" },',
  '{ "@type": "Country", "name": "VE" },',
  '{ "@type": "Country", "name": "VG" },',
  '{ "@type": "Country", "name": "VU" }',
]
export const ACCEPTABLE_SHIPPING_COUNTRIES_ISO3166_FOR_JSON_LD: string =
  ACCEPTABLE_SHIPPING_COUNTRIES_ISO3166_FOR_JSON_LD_RAW.join(' ')
export const SHIPPING_DESTINATIONS_SOFTWARE_ONLY_REFUND_COUNTRIES_ISO3166_FOR_JSON_LD_RAW_1: any =
  [
    '{ "@type": "DefinedRegion", "addressCountry": "US" },',
    '{ "@type": "DefinedRegion", "addressCountry": "CA" },',
    '{ "@type": "DefinedRegion", "addressCountry": "AT" },',
    '{ "@type": "DefinedRegion", "addressCountry": "BE" },',
    '{ "@type": "DefinedRegion", "addressCountry": "BG" },',
    '{ "@type": "DefinedRegion", "addressCountry": "CH" },',
    '{ "@type": "DefinedRegion", "addressCountry": "CY" },',
    '{ "@type": "DefinedRegion", "addressCountry": "CZ" },',
    '{ "@type": "DefinedRegion", "addressCountry": "DE" },',
    '{ "@type": "DefinedRegion", "addressCountry": "DK" },',
    '{ "@type": "DefinedRegion", "addressCountry": "EE" },',
    '{ "@type": "DefinedRegion", "addressCountry": "ES" },',
    '{ "@type": "DefinedRegion", "addressCountry": "FI" },',
    '{ "@type": "DefinedRegion", "addressCountry": "FR" },',
    '{ "@type": "DefinedRegion", "addressCountry": "GB" },',
    '{ "@type": "DefinedRegion", "addressCountry": "GD" },',
    '{ "@type": "DefinedRegion", "addressCountry": "GE" },',
    '{ "@type": "DefinedRegion", "addressCountry": "GR" },',
    '{ "@type": "DefinedRegion", "addressCountry": "GU" },',
    '{ "@type": "DefinedRegion", "addressCountry": "HN" },',
    '{ "@type": "DefinedRegion", "addressCountry": "HU" },',
    '{ "@type": "DefinedRegion", "addressCountry": "ID" },',
    '{ "@type": "DefinedRegion", "addressCountry": "IE" },',
    '{ "@type": "DefinedRegion", "addressCountry": "IL" },',
    '{ "@type": "DefinedRegion", "addressCountry": "IN" },',
    '{ "@type": "DefinedRegion", "addressCountry": "IS" },',
    '{ "@type": "DefinedRegion", "addressCountry": "IT" },',
    '{ "@type": "DefinedRegion", "addressCountry": "JE" },',
    '{ "@type": "DefinedRegion", "addressCountry": "JM" },',
    '{ "@type": "DefinedRegion", "addressCountry": "JP" },',
    '{ "@type": "DefinedRegion", "addressCountry": "KN" },',
    '{ "@type": "DefinedRegion", "addressCountry": "KR" },',
    '{ "@type": "DefinedRegion", "addressCountry": "KY" },',
    '{ "@type": "DefinedRegion", "addressCountry": "LC" },',
    '{ "@type": "DefinedRegion", "addressCountry": "LI" },',
    '{ "@type": "DefinedRegion", "addressCountry": "LV" },',
    '{ "@type": "DefinedRegion", "addressCountry": "LT" },',
    '{ "@type": "DefinedRegion", "addressCountry": "LU" },',
    '{ "@type": "DefinedRegion", "addressCountry": "LV" },',
    '{ "@type": "DefinedRegion", "addressCountry": "MF" },',
    '{ "@type": "DefinedRegion", "addressCountry": "ML" },',
    '{ "@type": "DefinedRegion", "addressCountry": "MQ" },',
    '{ "@type": "DefinedRegion", "addressCountry": "MT" },',
    '{ "@type": "DefinedRegion", "addressCountry": "MV" },',
    '{ "@type": "DefinedRegion", "addressCountry": "MY" },',
    '{ "@type": "DefinedRegion", "addressCountry": "NL" },',
    '{ "@type": "DefinedRegion", "addressCountry": "NO" },',
    '{ "@type": "DefinedRegion", "addressCountry": "PG" },',
    '{ "@type": "DefinedRegion", "addressCountry": "PL" },',
    '{ "@type": "DefinedRegion", "addressCountry": "PT" }',
  ]
export const SHIPPING_DESTINATIONS_SOFTWARE_ONLY_REFUND_COUNTRIES_ISO3166_FOR_JSON_LD_1: string =
  SHIPPING_DESTINATIONS_SOFTWARE_ONLY_REFUND_COUNTRIES_ISO3166_FOR_JSON_LD_RAW_1.join(
    ' ',
  )
export const SHIPPING_DESTINATIONS_SOFTWARE_ONLY_REFUND_COUNTRIES_ISO3166_FOR_JSON_LD_RAW_2: any =
  [
    '{ "@type": "DefinedRegion", "addressCountry": "RO" },',
    '{ "@type": "DefinedRegion", "addressCountry": "SB" },',
    '{ "@type": "DefinedRegion", "addressCountry": "SG" },',
    '{ "@type": "DefinedRegion", "addressCountry": "SK" },',
    '{ "@type": "DefinedRegion", "addressCountry": "SI" },',
    '{ "@type": "DefinedRegion", "addressCountry": "SE" },',
    '{ "@type": "DefinedRegion", "addressCountry": "SV" },',
    '{ "@type": "DefinedRegion", "addressCountry": "SX" },',
    '{ "@type": "DefinedRegion", "addressCountry": "TC" },',
    '{ "@type": "DefinedRegion", "addressCountry": "TH" },',
    '{ "@type": "DefinedRegion", "addressCountry": "TK" },',
    '{ "@type": "DefinedRegion", "addressCountry": "UY" },',
    '{ "@type": "DefinedRegion", "addressCountry": "VA" },',
    '{ "@type": "DefinedRegion", "addressCountry": "VC" },',
    '{ "@type": "DefinedRegion", "addressCountry": "VE" },',
    '{ "@type": "DefinedRegion", "addressCountry": "VG" },',
    '{ "@type": "DefinedRegion", "addressCountry": "VU" }',
  ]
export const SHIPPING_DESTINATIONS_SOFTWARE_ONLY_REFUND_COUNTRIES_ISO3166_FOR_JSON_LD_2: string =
  SHIPPING_DESTINATIONS_SOFTWARE_ONLY_REFUND_COUNTRIES_ISO3166_FOR_JSON_LD_RAW_2.join(
    ' ',
  )
export const ACCEPTABLE_SOFTWARE_ONLY_REFUND_COUNTRIES_ISO3166_FOR_JSON_LD_1: string = `"US", "CA", "AT", "BE", "BG", "CH", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR", "GB", "GD", "GE", "GR", "GU", "HN", "HU", "ID", "IE", "IL", "IN", "IS", "IT", "JE", "JM", "JP", "KN", "KR", "KY", "LC", "LI", "LV", "LT", "LU", "MF", "ML", "MQ", "MT", "MV", "MY", "NL", "NO", "PG", "PL", "PT"`
export const ACCEPTABLE_SOFTWARE_ONLY_REFUND_COUNTRIES_ISO3166_FOR_JSON_LD_2: string = `"PY", "RO", "SB", "SG", "SK", "SI", "SE", "SV", "SX", "TC", "TH", "TK", "UY", "VA", "VC", "VE", "VG", "VU"`

export const BLOCK_INSECURE_SITES: boolean = false
